import { useEffect, useState } from "react";
import "../css/ageVerificationPopup.css";

function AgeVerificationPopup() {

  const [show, setShow] = useState(false);

  useEffect(() => {

    const verified = localStorage.getItem("ageVerified");

    if (!verified) {
      setShow(true);
    }

  }, []);

  const handleYes = () => {

    localStorage.setItem("ageVerified", "true");

    setShow(false);

  };

  const handleNo = () => {

    window.location.href = "https://www.google.com";

  };

  if (!show) return null;

  return (

    <div className="age-popup-overlay">

      <div className="age-popup">

        <h2>Age Verification</h2>

        <p>
          You must be 21 years or older to enter this website.
        </p>

        <div className="age-buttons">

          <button
            className="yes-btn"
            onClick={handleYes}
          >
            I am 21+
          </button>

          <button
            className="no-btn"
            onClick={handleNo}
          >
            Under 21
          </button>

        </div>

      </div>

    </div>

  );

}

export default AgeVerificationPopup;